import React, { useState, useEffect } from "react";
import {getIdData } from "../../../lib/instructorinfo"
import {updateData } from "../../../lib/profiles"
import { useNavigate, useParams } from 'react-router-dom';

export default function AdminAddInstructorStep2() {
  const [name, setName] = useState();
  const [surname, setSurname] = useState();
  const [phone, setPhone] = useState();
  const [username, setUserName] = useState();
  const navigate = useNavigate();
  let { slug,type } = useParams();
  //const [studentInfo, setStudentInfo] = useState();


//console.log("category",category);

  const handleSubmit = async (e) => {
    e.preventDefault();

      await updateData({
        id: slug,
        username: username,
        name: name,
        surname: surname,
        phone:phone,
      });
      navigate(`/admin/admin-instructorstep3/${slug}`);
      //navigate(`/admin/admin-instructordetail/${slug}`);
  };

  async function GetData() {
    const info = await getIdData(slug);
    //setStudentInfo(info);
    setName(info[0].name);
    setSurname(info[0].surname);
    setPhone(info[0].phone);
    setUserName(info[0].username);
    console.log("info",info);
  }

  useEffect(() => {

    if (type==="Update")
        GetData();
  
}, [])


  return (
            <div className="col-xl-12 col-md-12">
              <div className="settings-widget profile-details">
                <div className="settings-menu p-2">
                  <div className="profile-heading p-2">
                    <h3>{type==="Add"? "Add Instructor" : "Update Instructor"}</h3>
                  </div>
                  <div className="checkout-form personal-address add-course-info ">
                    <form role="form" onSubmit={handleSubmit}>
                      <div className="row mx-auto">
                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">
                              Name
                            </label>
                            <input
                              type="text"
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                              className="form-control"
                              placeholder="Enter Name"
                              required
                            />
                          </div>
                        </div>
                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">
                              Surname
                            </label>
                            <input
                              type="text"
                              value={surname}
                              onChange={(e) => setSurname(e.target.value)}
                              className="form-control"
                              placeholder="Enter Surname"
                              required
                            />
                          </div>
                        </div>
                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">
                              Phone
                            </label>
                            <input
                             name="phone" placeholder="123-45-67" pattern="[0-9]{3}-[0-9]{2}-[0-9]{2}"
                              value={phone}
                              onChange={(e) => setPhone(e.target.value)}
                              className="form-control"
                            />
                          </div>
                        </div>
                        {/*}
                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">
                              School 
                            </label>
                            <DropDown options={options}  setCategory = {setCategory} />
                          </div>
                        </div>
  {*/}
                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">
                              Nick Name
                            </label>
                            <input
                             name="text" 
                              value={username}
                              onChange={(e) => setUserName(e.target.value)}
                              className="form-control"
                              placeholder="Enter Nick Name" 
                            />
                          </div>
                        </div>
                        <div className="update-profile d-flex justify-content-between">
                          <button type="submit"  className="btn btn-primary">
                          {type==="Add"? "Next Step >>"  : "Update"}
                          </button>
                          <button onClick={() => navigate(-1)} className="btn btn-black btn-sm">
                          Cancel
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

  );
}
